<template>
    <div>
        <div class="buttons-tab">
            <div class="buttons-tab__item" v-for="(item, index) of tabs" :key="index">
                <div
                    class="buttons-tab__control"
                    @click="changeTab(item.value)"
                    :class="{ 'is-active': tab === item.value }"
                >
                    {{ item.label }}
                </div>
            </div>
        </div>
        <div class="content-container">
            <template v-if="tab === 'icons'">
                <v-input name="search-icon" placeholder="Поиск..." v-model="searchedIcon" style="margin-bottom: 20px" />
                <color-dropdown
                    title="Цвет иконки"
                    style="margin-bottom: 20px"
                    :value="icon.color"
                    @update-color="updateColor"
                />
                <div class="icons-container" ref="iconsList">
                    <div class="icon-box" :class="{ 'is-active': !icon.svg }" @click="chooseIcon(null)">
                        Нет
                    </div>
                    <div
                        class="icon-box"
                        v-for="(item, index) of iconsList"
                        :key="index"
                        @click="chooseIcon(item)"
                        :class="{ 'is-active': icon.svg === item }"
                    >
                        <svg>
                            <use
                                v-bind="{
                                    'xlink:href': `${require('@/assets/taplink-icons/icons-sprite.svg')}#tabler-${item}`
                                }"
                            ></use>
                        </svg>
                    </div>
                </div>
                <v-paginate :total="totalPages" :current-page="currentPage" @change="changePage" />
            </template>
            <div v-else-if="tab === 'images'">
                <upload-images
                    style="max-width: 88px"
                    mini
                    v-model="icon.image"
                    @change="uploadImage"
                    @click="icon.type = 'image'"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { ICON_COLLECTION } from "./Icons";
import ColorDropdown from "../../../../../common/components/color-panel/ColorDropdown";
import UploadImages from "../common/UploadImages";

const perPage = 100;
export default {
    name: "TaplinkBtnIcons",
    components: {
        UploadImages,
        ColorDropdown
    },
    props: {
        icon: {}
    },
    data() {
        return {
            icons: ICON_COLLECTION,
            loading: false,
            currentPage: 1,
            tabs: [
                { value: "icons", label: "Иконки" },
                { value: "images", label: "Изображения" }
            ],
            buttonIcon: null,
            searchedIcon: "",
            tab: "icons"
        };
    },
    computed: {
        totalPages() {
            return Math.ceil(this.currentIconList.length / perPage);
        },
        currentIconList() {
            return this.icons.filter(icon => icon.includes(this.searchedIcon));
        },
        iconsList() {
            return this.currentIconList.slice(
                (this.currentPage - 1) * perPage,
                (this.currentPage - 1) * perPage + perPage
            );
        }
    },
    methods: {
        changePage(page) {
            this.currentPage = page;
            this.$refs.iconsList.scrollTo(0, 0);
        },
        changeTab(tab) {
            if (this.tab !== tab) {
                this.tab = tab;
            }
        },
        chooseIcon(icon) {
            console.log(this.icon, "icon");
            if (this.icon.type !== "icon") {
                this.icon.type = "icon";
            }
            if (this.icon.svg !== icon) {
                this.icon.svg = icon;
            }
        },
        uploadImage() {
            this.icon.type = "image";
        },
        updateColor(color) {
            this.icon.color = color;
        }
    }
};
</script>

<style lang="scss">
.buttons-tab {
    border-radius: 2px;
    background: #eaedef;
    display: flex;

    &__item {
        flex-grow: 1;
        flex-shrink: 1;
        padding: 4px;
    }

    &__control {
        text-align: center;
        font-size: 14px;
        border-color: transparent;
        color: #606e75;
        border-radius: 2px;
        cursor: pointer;

        &.is-active {
            background: #fff;
        }
    }
}

.content-container {
    padding: 15px 0;
}

.icons-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(65px, 1fr));
    grid-auto-flow: dense;
    justify-content: center;
    align-items: center;
    gap: 10px;
    max-height: 400px;
    overflow-y: auto;

    .icon-box {
        position: relative;
        height: 70px;
        border-radius: 4px;
        border: 2px solid #dbdbdb;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px;
        cursor: pointer;

        &:hover {
            border-color: #000;
        }

        &.is-active {
            border-color: #5db85b;
            background: #5cb95b26;
        }
    }

    svg {
        height: 35px;
        width: 35px;
    }
}
</style>
